<template>
<div>
    <Breadcrumbs main="Sales" submain="Fulfillment" title="Batches" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">

                        <button class="btn btn-primary" type="submit" v-b-modal.batch-create-modal style="display: flex; gap: 12px; align-items: center; margin-top: 24px;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Create Batch</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="3" label="Per page" class="mb-0 w-100 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div v-if="!loading && !error">

                            <div class="mt-4 table-responsive datatable-vue">
                                <b-table show-empty stacked="md" small responsive :items="items" :fields="tablefields" :filter="filter" :per-page="perPage" @filtered="onFiltered">

                                    <!-- Serial -->
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <!-- Batch ID -->
                                    <template #cell(batch_id)="data">
                                        {{ data.item.batch_id || '-' }}
                                    </template>

                                    <!-- Route -->
                                    <template #cell(route)="data">
                                        {{ data.item.route?.name || '-' }}
                                    </template>

                                    <!-- Territory -->
                                    <template #cell(territory)="data">
                                        {{ data.item.route?.territory?.name || '-' }}
                                    </template>

                                    <!-- Vehicle -->
                                    <template #cell(vehicle)="data">
                                        {{ data.item.vehicle || '-' }}
                                    </template>

                                    <!-- Status -->
                                    <template #cell(status)="data">
                                        <span class="badge bg-warning text-dark text-uppercase">
                                            {{ data.item.status }}
                                        </span>
                                    </template>

                                    <!-- Stops -->
                                    <template #cell(total_stops)="data">
                                        {{ data.item.total_stops }}
                                    </template>

                                    <!-- Amount -->
                                    <template #cell(total_amount)="data">
                                        {{ data.item.total_amount }}
                                    </template>

                                    <!-- Created By -->
                                    <template #cell(created_by)="data">
                                        {{ data.item.created_by?.full_name || '-' }}
                                    </template>

                                    <!-- Expand Button -->
                                    <template #cell(actions)="row">
                                        <button class="btn btn-sm btn-primary" @click="row.toggleDetails">
                                            {{ row.detailsShowing ? 'Hide' : 'Preview Challans' }}
                                        </button>
                                    </template>

                                    <!-- Expandable Row -->
                                    <template #row-details="row">
                                        <div class="p-3 rounded">

                                            <h6 class="mb-3">
                                                Challan Preview
                                            </h6>

                                            <div v-for="challanItem in row.item.batch_challans" :key="challanItem.id" class="p-3 mb-3 border rounded ">
                                                <div class="row">

                                                    <div class="col-md-3 mb-2">
                                                        <strong>Challan ID:</strong><br>
                                                        {{ challanItem.challan?.challan_id }}
                                                    </div>

                                                    <div class="col-md-3 mb-2">
                                                        <strong>Customer:</strong><br>
                                                        {{ challanItem.challan?.customer?.name }}
                                                    </div>

                                                    <div class="col-md-3 mb-2">
                                                        <strong>Order ID:</strong><br>
                                                        {{ challanItem.challan?.order?.order_id }}
                                                    </div>

                                                    <div class="col-md-3 mb-2">
                                                        <strong>Invoice ID:</strong><br>
                                                        {{ challanItem.challan?.invoice?.invoice_id }}
                                                    </div>

                                                    <div class="col-md-3 mb-2">
                                                        <strong>Invoice Status:</strong><br>
                                                        {{ challanItem.challan?.invoice?.status }}
                                                    </div>

                                                    <div class="col-md-3 mb-2">
                                                        <strong>Total:</strong><br>
                                                        {{ challanItem.challan?.invoice?.total }}
                                                    </div>

                                                    <div class="col-md-3 mb-2">
                                                        <strong>Paid:</strong><br>
                                                        {{ challanItem.challan?.invoice?.paid_amount }}
                                                    </div>

                                                    <div class="col-md-3 mb-2">
                                                        <strong>Due:</strong><br>
                                                        {{ challanItem.challan?.invoice?.due_amount }}
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </template>

                                </b-table>
                            </div>
                        </div>
                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                           <b-col class="my-1 p-0">
                                    <b-row class="mt-3">
                                        <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                            <span>
                                                <!-- First Page Button (<<) -->
                                                <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                                    <b-icon icon="chevron-double-left"></b-icon>
                                                </button>

                                                <!-- Previous Page Button (<) -->

                                                <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                                    <b-icon icon="chevron-left"></b-icon>
                                                </button>
                                            </span>

                                            <span class="align-self-center">
                                                <span class="align-self-center">
                                                    <span class="d-flex align-items-center" style="gap: 6px;">
                                                        <span>Page</span>
                                                        <b-form-input v-model="pageInput" style="box-shadow: none; max-width: 40px;" @input="handlePageInput" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1" :max="totalPages"></b-form-input>
                                                        <span>of {{ totalPages }}</span>
                                                    </span>
                                                </span>
                                            </span>

                                            <span>
                                                <!-- Next Page Button (>) -->
                                                <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                                    <b-icon icon="chevron-right"></b-icon>
                                                </button>

                                                <!-- Last Page Button (>>) -->
                                                <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                                    <b-icon icon="chevron-double-right"></b-icon>
                                                </button>
                                            </span>
                                        </b-col>
                                    </b-row>
                                </b-col>

                    </div>
                </div>
            </div>
        </div>

    </div>


       <!-- Batch create -->
    <b-modal id="batch-create-modal" size="lg" ref="modal" title="Create Batch" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="Vehicle" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="batchItem.vehicle" placeholder="Enter vehicle Name"></b-form-input>
            </b-form-group>


            <div class="form-group">
                <label>Route</label>
                <v-select  class="custom-vue-select" :options="route_list" label="name" :reduce="t => t.id" v-model="batchItem.route" placeholder="Select a route"></v-select>
            </div>
            

            <div class="form-group">
                <label>Challan</label>
                <multiselect v-model="selectedChallans" tag-placeholder="" placeholder="Search challan" label="challan_id" :max="challans.length" track-by="id"  :options="challans" :multiple="true" :taggable="true"></multiselect>
            </div>

            <b-form-group label="Remarks" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="batchItem.remarks" placeholder="Enter remarks here.."></b-form-input>
            </b-form-group>
        </form>
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
export default {
    components: {
        Multiselect,
        Datepicker,
        'v-select': vSelect,

    },

    data() {
        return {
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'batch_id',
                    label: 'Batch ID'
                },
                {
                    key: 'route',
                    label: 'Route'
                },
                {
                    key: 'territory',
                    label: 'Territory'
                },
                {
                    key: 'vehicle',
                    label: 'Vehicle'
                },
                {
                    key: 'status',
                    label: 'Status'
                },
                {
                    key: 'total_stops',
                    label: 'Stops'
                },
                {
                    key: 'total_amount',
                    label: 'Amount'
                },
                {
                    key: 'created_by',
                    label: 'Created By'
                },
                {
                    key: 'actions',
                    label: 'Actions'
                }
            ],

            filter: null,
            initialLoad: true,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],

            nameState: null,
            loadingPage: false,
            pageInput: 1,
            pageInputDebounce: null,

            batchItem:{
                route: null,
                vehicle: null,
                remarks: '',
                challans:[]
            },
            selectedChallans: []

        };
    },

    computed: {
        ...mapState({
            items: state => state.order.challan_batch,
            loading: state => state.order.batchLoading,
            error: state => state.order.batchError,
            challans: state => state.order.sales_fulfillment,
            route_list: state => state.territory.route,
            // count: state => state.lead.lead_count,
        }),
        count() {
            return this.items?.length || 0
        },

        totalPages() {
            return Math.ceil(this.count / this.perPage);
        },

    },

    mounted() {

        const query = this.$route.query;
        this.currentPage = parseInt(query.page) || 1;
        this.pageInput = this.currentPage;
        this.perPage = parseInt(query.perPage) || 25;

        this.updateRouteQuery();
        this.fetchInitialUpdate();

        this.$store.dispatch("order/fetchFulfillment", {perPage : null, currentPage:null})
        this.$store.dispatch("territory/fetchRoute")

        
    },

    watch: {

        currentPage(newVal, oldVal) {
            if (this.pageInput != newVal) {
                this.pageInput = newVal;
            }
            if (!this.loadingPage && !this.initialLoad) {
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        perPage(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },

    },

    methods: {

        updateRouteQuery() {
            const query = {
                page: this.currentPage,
                perPage: this.perPage
            }

            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({
                    path: this.$route.path,
                    query
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        },
        fetchInitialUpdate() {
            this.$store.dispatch("order/getchallanBatch", {
                perPage: this.perPage,
                currentPage: this.currentPage,

            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        fetchData() {
            if (!this.initialLoad) {
                this.$store.dispatch("order/getchallanBatch", {
                    perPage: this.perPage,
                    currentPage: this.currentPage,

                }).then(() => {
                    this.totalRows = this.count;
                });
            }
        },
        formatDateTime(date) {
            return new Date(date).toLocaleString('en-BD', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        },
        handlePageInput() {

            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
            }

            if (!this.pageInput || this.pageInput === '') {
                return;
            }

            this.pageInputDebounce = setTimeout(() => {
                this.validatePage();
            }, 800);
        },

        validatePage() {
            this.loadingPage = true;

            // Clear debounce timer
            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
                this.pageInputDebounce = null;
            }

            const totalPages = this.totalPages;
            let page = parseInt(this.pageInput);

            if (!page || isNaN(page) || page < 1) {
                page = 1;
            } else if (page > totalPages) {
                page = totalPages;
            }

            this.pageInput = page;
            this.currentPage = page;

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
            this.pageInput = page; // Update input too
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.batchItem.route = null
            this.batchItem.vehicle = null
            this.batchItem.remarks = ''
            this.batchItem.challans = []
            this.selectedChallans = []
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },
        handleSubmit(){
            if(this.selectedChallans?.length > 0) {
                this.selectedChallans.map(item => {
                    this.batchItem.challans.push(item.id)
                })
            }
            this.$store.dispatch("order/challanBatchCreate", this.batchItem).then(response => {
              
                if (response.code == 201) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.selectedChallans = []
                
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            this.$nextTick(() => {
                this.$bvModal.hide('batch-create-modal')
            })
        },
    }
};
</script>

<style scoped>
.mini-box {
    flex: 0 0 220px;
    width: 220px;
    padding: 16px 24px;
    border-radius: 8px;
    transition: 0.3s ease;
    background-color: #ffffff;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

}

.mini-box:hover {
    transform: translateY(-3px);
}

.mini-label {
    font-size: 14px;
    font-weight: 600;
    color: #62748e;
}

.mini-value {
    font-size: 18px;
    font-weight: 700;

}

/* Stage */
.stage-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px 12px;
    border-radius: 30px;
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
    min-width: 90px;
    letter-spacing: 0.3px;
    border: 1px solid transparent;
}

/* Stages */
.stage-suspect {
    background: #f3f4f6;
    color: #6b7280;

}

.stage-qualified {
    background: #dbeafe;
    color: #2563eb;
}

.stage-discovery {
    background: #ede9fe;
    color: #7c3aed;
}

.stage-demo {
    background: #cffafe;
    color: #0891b2;
}

.stage-proposal {
    background: #fef3c7;
    color: #d97706;
}

.stage-trial {
    background: #fee2e2;
    color: #dc2626;
}

.stage-customer {
    background: #dcfce7;
    color: #16a34a;
}

.status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px 12px;
    border-radius: 30px;
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
    min-width: 90px;
    letter-spacing: 0.3px;
    border: 1px solid transparent;
}

/* None */
.status-none {
    background: #f1f3f5;
    color: #6c757d;
    border-color: #dee2e6;
}

/* Pending */
.status-pending {
    background: rgba(255, 193, 7, 0.12);
    color: #b78103;
    border-color: rgba(255, 193, 7, 0.3);
}

/* Approved */
.status-approved {
    background: rgba(25, 135, 84, 0.12);
    color: #198754;
    border-color: rgba(25, 135, 84, 0.25);
}

/* Rejected */
.status-rejected {
    background: rgba(220, 53, 69, 0.12);
    color: #dc3545;
    border-color: rgba(220, 53, 69, 0.25);
}

.custom-status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 14px;
    border-radius: 30px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.3px;
    min-width: 90px;
    text-transform: capitalize;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid transparent;
}

.custom-status-badge:hover {
    transform: translateY(-1px);
    opacity: 0.9;
}

/* Open */
.status-open {
    background: rgba(13, 110, 253, 0.12);
    color: #0d6efd;
    border-color: rgba(13, 110, 253, 0.25);
}

/* Active */
.status-active {
    background: rgba(25, 135, 84, 0.12);
    color: #198754;
    border-color: rgba(25, 135, 84, 0.25);
}

/* Hold */
.status-hold {
    background: rgba(255, 193, 7, 0.12);
    color: #b78103;
    border-color: rgba(255, 193, 7, 0.3);
}

/* Lost */
.status-lost {
    background: rgba(108, 117, 125, 0.12);
    color: #6c757d;
    border-color: rgba(108, 117, 125, 0.25);
}

/* Converted */
.status-converted {
    background: rgba(13, 202, 240, 0.12);
    color: #0dcaf0;
    border-color: rgba(13, 202, 240, 0.25);
}
</style>
